import firebase from '@/firebase'
import { FS_COLLECTIONS } from '@/firebase'
import { TIPO_PERFIL } from '@/constantes/usuarios.js'
import {PRODUCCION, URL_CLUDSF} from '@/constantes/environment'
import errors from "@/errors";
import axios from "axios";
import { config } from '@/firebase.js'
const db = firebase.firestore()
const storage = firebase.storage().ref()
var firebaseAlterno = null
var cargadorIndicePropietarios = null
var cargadorIndicePropietariosConSaldo = null
//var cargadorPropietario = null

const store = {
  state: {
    //propietarios: [],
    indicePropietarios: [],
    indicePropietariosConSaldo:{},
    indicePropietariosPacientes: [],
    propietario: {},
    propietarioSeleccionado: {},
    propietarioActual:{},
    propietarioTiempoReal:{},
  },
  getters: {
    /* propietarios(state, rootGetters) {
      //console.log(rootGetters)
      return state.propietarios
    },
     propietarioPorID(state) {
      return id => state.propietarios.find(propietario => propietario.id === id)
    }, */
    propietarioSeleccionado(state) {
      return state.propietarioSeleccionado
    },
    propietarioActual(state) {
      return state.propietarioActual
    },
    // Indice Propietarios
    indicePropietarios(state) {
      return state.indicePropietarios
    },
    indicePropietariosConSaldo(state){
      return state.indicePropietariosConSaldo
    },
    indicePropietariosPacientes(state) {
      return state.indicePropietariosPacientes
    },
    propietarioTiempoReal(state){
      return state.propietarioTiempoReal
    }
  },
  mutations: {
    // Indice Propietarios
    ASIGNA_INDICE_PROPIETARIOS(state, indice) {
      state.indicePropietarios = indice
    },
    ASIGNA_INDICE_PROPIETARIOS_CON_SALDO(state, indice){
      state.indicePropietariosConSaldo = indice
    },
    ASIGNA_PROPIETARIO(state, propietario) {
      state.propietario = propietario
    },
    ASIGNA_PROPIETARIO_ACTUAL(state,propietario){
      state.propietarioActual = propietario;
    },
    ASIGNA_INDICE_PROPIETARIOSPACIENTE(state, indice) {
      state.indicePropietariosPacientes = indice
    },
    ASIGNA_PROPIETARIO_TIEMPO_REAL(state,propietario){
      state.propietarioTiempoReal = propietario;
    }
    
  },
  actions: {
    // INICIO INDICES
    cargaIndicePropietarios({ commit, getters }) { 
      return new Promise((resolve, reject) => {
        if (getters.indicePropietarios === null) {
          if (typeof cargadorIndicePropietarios === 'function') {
            cargadorIndicePropietarios()
          }
          cargadorIndicePropietarios = null
          //console.log('getters.cargadorIndicePropietarios === null')
        }
        if (cargadorIndicePropietarios === null) {
          ///Franquicias/BF2Iny6XE5EeQLqPErQv/Indices/Propietarios
          //console.log('getters.franquicia.id: ' + getters.franquicia.id)
          let docPath = db
            .collection(FS_COLLECTIONS.FRANQUICIAS)
            .doc(getters.franquicia.id)
            .collection(FS_COLLECTIONS.PROPIETARIOS_INDICESV2);
          //console.log(docPath)
          cargadorIndicePropietarios = docPath.onSnapshot(docs => {
            //console.log('cargaIndicePropietarios data: ', doc.data())

            const listaResultado = {}
            docs.forEach(e => {
            const propietarios = e.data() || {}
            for(const i in propietarios){
              listaResultado[i] = {
                ...propietarios[i],
                id:i,
              }
            }

          })
            
            commit('ASIGNA_INDICE_PROPIETARIOS', listaResultado)
            commit('ASIGNA_INDICE_PROPIETARIOSPACIENTE', listaResultado) //PARA LA AGENDA
            
            resolve(listaResultado)
          })
        } else {
          resolve()
        }
      })
    },
    cargaPropietario({ commit }, idPropietario) {
      //console.log('1 store cargaPropietario: ' + idPropietario)
      return new Promise((resolve, reject) => {
        let docPath = db
          .collection(FS_COLLECTIONS.PROPIETARIOS)
          .doc(idPropietario)
        docPath.get().then(doc => {
          //console.log('2 propietario Cargado: ', doc.data().id)
          commit('ASIGNA_PROPIETARIO', doc.data())
          commit('ASIGNA_PROPIETARIO_ACTUAL', doc.data())
          resolve(doc.data())
        })
      })
      //return cargadorPropietario
    },
    cargaPropietarioTiempoReal({ commit }, idPropietario) {
      return new Promise((resolve, reject) => {
        db.collection(FS_COLLECTIONS.PROPIETARIOS)
        .doc(idPropietario)
        .onSnapshot(doc => {
          commit('ASIGNA_PROPIETARIO_TIEMPO_REAL', doc.data())
          resolve()
        })
      })
    },
    numeroDePacientesUsuario({}, idFranquicia){
      return new Promise((resolve, reject) => {
        let contador = 0;
        let docPath = db
          .collection(FS_COLLECTIONS.PACIENTES)
          .where("id_franquicia", "==", idFranquicia);
        docPath.get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
              contador++;
              //console.log(doc.id, ' => ', doc.data());
          });

          resolve(contador)
      });
      })
    },
    numeroDePropietariosUsuario({}, idFranquicia){
      return new Promise((resolve, reject) => {
        let contador = 0;
        let docPath = db
          .collection(FS_COLLECTIONS.PROPIETARIOS)
          .where("franquicia", "==", idFranquicia);
        docPath.get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
              contador++;
              //console.log(doc.id, ' => ', doc.data());
          });

          resolve(contador)
      });
      })
    },
    // FIN INDICES
    /* agregarPropietario({}, propietario) {
      var user = firebase.auth().currentUser
      // User Identifier
      propietario.usuario_padre = user.uid
      propietario.franquicia = 'BF2Iny6XE5EeQLqPErQv'
      return db.collection('Propietarios').add(propietario)
    }, */


    existeUsuario({}, email) {
      return new Promise((resolve, reject) => {
       
        db.collection('Propietarios')
          .where("datos_contacto.correo", "==", email)
          .get()
          .then(doc => {
            if (doc.empty) {
              resolve({ existe: false, id: null });
            } else {
              resolve({
                existe: true,
                id: doc.docs[0].id,
                data: doc.docs[0].data()
              });
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },


    existePropietario({}, uid){
      //console.log("🚀 ~ file: propietarios.js ~ line 293 ~ existePropietario ~ uid", uid)
      return new Promise((resolve, reject) => {
       
        db.collection('Propietarios')
        .doc(uid+'')
        .get()
        .then(doc => {
            console.log("🚀 ~ file: propietarios.js ~ line 300 ~ returnnewPromise ~ doc", doc)
            if (!doc.exists) {
              resolve(false);
            } else {
              resolve(true);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },


    async agregarNuevoPropietario({ state, getters, dispatch }, propietario) {
      return new Promise(async (resolve, reject) => {
        //console.log(propietario)
        state.propietarioSeleccionado = propietario
        propietario.franquicia = getters.franquicia.id
        propietario.id_corporativo = getters.corporativo.id





        const dataJsonUsuario = JSON.stringify(propietario);

        let urlCrearUsuario = URL_CLUDSF+'/wsCrearPropietario';
        
        const res = await axios.post(urlCrearUsuario, dataJsonUsuario, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
        console.log('respuesta firebase',res.data);

        if(res.data.error){
          // if(res.data.error.code == "auth/email-already-exists"){
          //   this.cargandoFormulario = false;
          //   this.loader = false;
          //   alert('Este correo ya esta registrado.'); //ESTO DEBE SER UN RESOLVE
          //   return false;
          // }
          resolve({guardado: false, dato: propietario, error: errors(res.data.error.code) })
          console.log('return 9383');
          
          return false;
        }

        if(!res.data.status){
          //alert('Ocurrio un error avisa al administrador.');
          resolve({guardado: false, dato: propietario, error: 'Error interno'})
          console.log('return 9384');
          
          return false;
        }





        if (firebaseAlterno === null) {
          firebaseAlterno = firebase.initializeApp(config, 'Alterno')
        }
        //console.log('Franquicia en propietarios: ' + getters.franquicia.id)
        // TODO: Manejo de diferentes errores
        //console.log('firebase.app.length: ' + firebase.app.length)

        let dbAlterno = firebaseAlterno.firestore()
        firebaseAlterno
          .auth()
          .signInWithEmailAndPassword(
            propietario.datos_contacto.correo,
            'ABcs9fsnf8s8uf8uw98j38j!!'
          )
          .then((userCredential) => {
            var user = userCredential.user;
            //console.log("CONSOLA DE USUARIO: ", user)
            //console.log(user);
            //Se envia la verificacion al correo
            firebaseAlterno
              .auth()
              .sendPasswordResetEmail(user.email)
              .then(function() {
                
                //resolve(res.data)
                propietario.id = res.data.id
                resolve({guardado: true, dato: propietario, error: ''})
               
              })
              .catch(function(error) {
                console.log(
                  'ERROR enviando la verificacion al propietario' +
                    error.message
                )
                resolve({guardado: false, dato: propietario, error: error.message})
              })
          })
          .catch(error => {
            console.log('error creando propietario: ' + error.message)
            resolve({guardado: false, dato: propietario, error: error.message})
          })
      })
    },

    eliminarPropietario({}, propietarioID) {
      return db
        .collection('Propietarios')
        .doc(propietarioID)
        .delete()
    },
    actualizarPropietario({ state, dispatch }, propietario) {
      return new Promise((resolve, reject) => {
        state.propietarioSeleccionado = propietario
        db.collection('Propietarios')
          .doc(propietario.id)
          .update(propietario)
          .then(() => {
            state.propietarioSeleccionado = propietario
            for (var k in propietario.pacientes) {
              let payload = {
                paciente: propietario.pacientes[k],
                propietario: propietario.id
              }
              dispatch('actualizaPacientePropietarioInv', payload)
            }
            resolve()
          })
      })
    },
    // agrega las relaciones de propietario en el documento de pacientes
    actualizaPacientePropietarioInv({}, payload) {
      console.log('paciente id: ')
      console.log(payload.paciente)
      console.log(payload.propietario)
      let docRef = db.collection(FS_COLLECTIONS.PACIENTES).doc(payload.paciente)
      db.runTransaction(transaction => {
        return transaction.get(docRef).then(doc => {
          if (!doc.exists) {
            throw 'Paciente no esiste!'
          }
          let paciente = doc.data()
          var propietarios = paciente.propietarios
          if (propietarios === undefined) {
            propietarios = []
          }

          if (!propietarios.includes(payload.propietario)) {
            propietarios.push(payload.propietario)
          }
          console.log(propietarios)
          transaction.update(docRef, { propietarios: propietarios })
        })
      })
    },
    // elimina las relaciones de propietario en la tabla de pacientes
    removerPacientePropietarioInv({}, payload) {
      console.log('paciente id: ')
      console.log(payload.paciente)
      console.log(payload.propietario)
      let docRef = db.collection(FS_COLLECTIONS.PACIENTES).doc(payload.paciente)
      db.runTransaction(transaction => {
        return transaction.get(docRef).then(doc => {
          if (!doc.exists) {
            throw 'Paciente no esiste!'
          }
          let paciente = doc.data()
          var propietarios = paciente.propietarios
          if (propietarios === undefined) {
            return
          }

          propietarios = paciente.propietarios.filter(ele => {
            return ele != payload.propietario
          })

          console.log(propietarios)
          transaction.update(docRef, { propietarios: propietarios })
        })
      })
    },
    subirArchivo({}, archivo) {
      var uid = firebase.auth().currentUser.uid
      //RmM51tSQN5OvsP2Ggk0DbPAvKWM2
      //foto.jpg
      //RmM51tSQN5OvsP2Ggk0DbPAvKWM2/foto.jpg
      return new Promise((resolve, reject) => {
        storage
          .child(`Clientes/${uid}/${archivo.name}`)
          .put(archivo)
          .then(uploadTaskSnapshot => {
            uploadTaskSnapshot.ref
              .getDownloadURL()
              .then(url => {
                resolve(url)
              })
              .catch(error => reject(error))
          })
          .catch(error => reject(error))
      })
    },
    subirArchivoPropietario({getters}, archivo) {
      var uid = firebase.auth().currentUser.uid
      //RmM51tSQN5OvsP2Ggk0DbPAvKWM2
      //foto.jpg
      //RmM51tSQN5OvsP2Ggk0DbPAvKWM2/foto.jpg
      return new Promise((resolve, reject) => {
        storage
          .child(`Franquicias/${getters.franquicia.id}/Propietarios/${archivo.idProp}/${archivo.name}`)
          .put(archivo)
          .then(uploadTaskSnapshot => {
            uploadTaskSnapshot.ref
              .getDownloadURL()
              .then(url => {
                resolve(url)
              })
              .catch(error => reject(error))
          })
          .catch(error => reject(error))
      })
    },
  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/propietarios/propietarios.js